import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataResidencyPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 498 191",
	preserveAspectRatio: "xMidYMid",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1313_28965)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 498,
				height: 191,
				rx: 16,
				fill: "#F2F7FE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M295.998 89.6792L401.394 89.6792V0.250275C343.211 0.364609 296.156 40.3801 295.998 89.6792Z",
				stroke: "#E86F00",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M498 80.3792L401.644 80.3792L401.644 0C454.852 1.94016e-06 498 35.98 498 80.3792Z",
				fill: "#FBEECA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M163.695 191.146L7.48269e-06 191.146L0 54.9124C90.393 54.9124 163.695 115.895 163.695 191.146Z",
				fill: "#FBE6F2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.332 117.494V86.3005H46.701C46.701 103.526 63.0981 117.494 83.332 117.494Z",
				fill: "#F1DD5A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.6979 86.4423L46.6979 50.088C46.6979 29.4589 25.5753 12.7332 -0.477039 12.7332L-0.477036 86.4423L46.6979 86.4423Z",
				stroke: "#F1DD5A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M498 77.9916L400.768 77.9916C315.548 77.9916 246.453 128.444 246.453 190.671L498 190.671L498 77.9916Z",
				fill: "#C5DBF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M250.908 92.3166L187.943 92.3166L187.943 142.454C222.712 142.454 250.908 120.011 250.908 92.3166Z",
				fill: "#E86F00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.943 142.454L242.995 142.454C274.235 142.454 299.563 164.191 299.563 191L187.943 191L187.943 142.454Z",
				fill: "#FBE6F2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.95 80.5292L187.95 -0.592041L90.5057 -0.592042C90.8274 44.0453 134.206 80.3056 187.95 80.5292Z",
				stroke: "#EECEE1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M188.42 89.929V191H67.2588C67.2588 135.188 121.494 89.929 188.42 89.929Z",
				fill: "#0045CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M452.966 190.519V152.004H408.322C408.322 173.272 428.306 190.519 452.966 190.519Z",
				fill: "#FBEECA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M453.161 190.671L453.161 114.605C453.161 94.5612 473.15 78.31 497.805 78.31L497.805 190.671L453.161 190.671Z",
				fill: "#0045CC"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 137,
				y: 24,
				width: 224,
				height: 144,
				rx: 72,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .4,
				d: "M267 96C267 100.312 266.625 104.25 266.25 108H231.562C231.188 104.25 230.812 100.312 230.812 96C230.812 91.875 231.188 87.9375 231.562 84H266.25C266.625 87.9375 267 91.875 267 96ZM295.312 84C296.438 87.9375 297 91.875 297 96C297 100.312 296.438 104.25 295.312 108H272.25C272.625 104.25 273 100.125 273 96C273 91.875 272.625 87.9375 272.25 84H295.312ZM293.438 78H271.5C269.625 66.1875 265.875 56.0625 261.188 49.6875C275.812 53.625 287.812 64.125 293.438 78ZM265.5 78H232.312C233.438 71.25 235.312 65.25 237.375 60.375C239.438 55.875 241.5 52.6875 243.75 50.625C245.812 48.75 247.5 48 249 48C250.312 48 252 48.75 254.062 50.625C256.312 52.6875 258.375 55.875 260.438 60.375C262.5 65.25 264.375 71.25 265.5 78ZM204.375 78C210 64.125 222 53.625 236.625 49.6875C231.938 56.0625 228.188 66.1875 226.312 78H204.375ZM225.562 84C225.188 87.9375 224.812 91.875 224.812 96C224.812 100.125 225.188 104.25 225.562 108H202.5C201.375 104.25 201 100.312 201 96C201 91.875 201.375 87.9375 202.5 84H225.562ZM237.375 131.812C235.312 126.938 233.438 120.938 232.312 114H265.5C264.375 120.938 262.5 126.938 260.438 131.812C258.375 136.312 256.312 139.5 254.062 141.562C252 143.438 250.312 144 248.812 144C247.5 144 245.812 143.438 243.75 141.562C241.5 139.5 239.438 136.312 237.375 131.812ZM236.625 142.5C222 138.562 210 128.062 204.375 114H226.312C228.188 126 231.938 136.125 236.625 142.5ZM261.188 142.5C265.875 136.125 269.625 126 271.5 114H293.438C287.812 128.062 275.812 138.562 261.188 142.5Z",
				fill: "#005CE6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M261.188 142.5C257.25 143.625 253.125 144 248.812 144C244.688 144 240.562 143.625 236.625 142.5C231.938 136.125 228.188 126 226.312 114H204.375C203.625 112.125 202.875 110.062 202.5 108H225.562C225.188 104.25 224.812 100.125 224.812 96C224.812 91.875 225.188 87.9375 225.562 84H202.5C202.875 81.9375 203.625 80.0625 204.375 78H226.312C228.188 66.1875 231.938 56.0625 236.625 49.6875C240.562 48.5625 244.688 48 248.812 48C247.5 48 245.812 48.75 243.75 50.625C241.5 52.6875 239.438 55.875 237.375 60.375C235.312 65.25 233.438 71.25 232.312 78H265.5C264.375 71.25 262.5 65.25 260.438 60.375C258.375 55.875 256.312 52.6875 254.062 50.625C252 48.75 250.312 48 248.812 48C253.125 48 257.25 48.5625 261.188 49.6875C265.875 56.0625 269.625 66.1875 271.5 78H293.438C294.188 80.0625 294.938 81.9375 295.312 84H272.25C272.625 87.9375 273 91.875 273 96C273 100.125 272.625 104.25 272.25 108H295.312C294.938 110.062 294.188 112.125 293.438 114H271.5C269.625 126 265.875 136.125 261.188 142.5ZM232.312 114C233.438 120.938 235.312 126.938 237.375 131.812C239.438 136.312 241.5 139.5 243.75 141.562C245.812 143.438 247.5 144 248.812 144C250.312 144 252 143.438 254.062 141.562C256.312 139.5 258.375 136.312 260.438 131.812C262.5 126.938 264.375 120.938 265.5 114H232.312ZM267 96C267 91.875 266.625 87.9375 266.25 84H231.562C231.188 87.9375 230.812 91.875 230.812 96C230.812 100.312 231.188 104.25 231.562 108H266.25C266.625 104.25 267 100.312 267 96Z",
				fill: "#005CE6"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1313_28965",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 498,
			height: 191,
			rx: 16,
			fill: "white"
		})
	}) })]
});
export { SvgDataResidencyPlaceholder as ReactComponent };
